import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const timeOptions = () => Array.from({ length: 24 }, (v, index) => [0, 15, 30, 45].map((interval) => moment({
  hour: index,
  minute: interval,
})
  .add(0, 'hours')
  .format('h:mm A'))).flat();

const TimeSelectComponent = ({
  label,
  value,
  onChange,
  sx,
  disabled,
}) => {
  const valueDate = moment(value).format('DD-MM-YYYY');
  return (
    <FormControl
      sx={sx}
      size="small"
    >
      <InputLabel id={`time-select-${value.getTime()}-label`}>{label}</InputLabel>
      <Select
        labelId={`time-select-${value.getTime()}-label`}
        id={`time-select-${value.getTime()}`}
        value={value.getTime()}
        label={label}
        onChange={onChange}
        MenuProps={{ style: { maxHeight: 400 } }}
        disabled={disabled}
      >
        {
          timeOptions().map((time) => (
            <MenuItem key={time} value={moment(`${valueDate} ${time}`, 'DD-MM-YYYY h:mm A').toDate().getTime()}>{time}</MenuItem>
          ))
        }
      </Select>
    </FormControl>
  );
};

TimeSelectComponent.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.object,
  disabled: PropTypes.bool,
};

TimeSelectComponent.defaultProps = {
  label: 'Time',
  value: new Date(),
  sx: {
    m: 1,
    minWidth: 120,
  },
  disabled: false,
};

export default (TimeSelectComponent);
